const SectionCard = ({ title, subtitle, action, children, isLoading = false, isEmpty = false, emptyText = "Belum ada data" }) => {
    return (
        <div className="overflow-hidden bg-white border border-neutral-200 rounded-2xl">
            <div className="flex items-center justify-between gap-4 px-5 py-4 border-b border-neutral-200 bg-neutral-50">
                <div>
                    <div className="text-sm font-semibold text-neutral-900">{title}</div>
                    {subtitle ? <div className="mt-0.5 text-xs text-neutral-500">{subtitle}</div> : null}
                </div>
                {action ? <div className="flex-shrink-0">{action}</div> : null}
            </div>
            <div className="p-5">
                {isLoading ? (
                    <div className="py-8 text-sm text-center text-neutral-400">Memuat data...</div>
                ) : isEmpty ? (
                    <div className="py-8 text-sm text-center text-neutral-400">{emptyText}</div>
                ) : (
                    children
                )}
            </div>
        </div>
    )
}

export default SectionCard
